import { AppRoute } from '@app/core/routing/AppRoute';
import { DefaultStationRedirect } from '@app/core/routing/DefaultStationRedirect';
import { SocialExportUploadPage } from '@app/modules/fragments/screens/upload/SocialExportUploadPage';
import { FragmentsViewPage } from '@app/modules/fragments/screens/view/FragmentsViewPage';
import { Switch } from 'react-router-dom';
import { Fragment } from '../types';
import { FragmentsListStationPage } from './FragmentsListStationPage';
import { FragmentsViewStationPage } from './FragmentsViewStationPage';

export const routeGenerator = {
  list: (stationId: string) => `/fragments/s/${stationId}`,
  view: (fragment: Fragment | string) =>
    `/fragments/${typeof fragment === 'string' ? fragment : fragment.id}`,
  audiogram: (fragment: Fragment) => `/fragments/${fragment.id}/audiogram`,
  upload: (fragment: Fragment, platform: { id: string }, projectId?: string) => {
    const base = `/fragments/${fragment.id}/upload/${platform.id.toLowerCase()}`;
    return projectId ? `${base}?projectId=${encodeURIComponent(projectId)}` : base;
  },
};

export function FragmentsRoutes() {
  return (
    <Switch>
      <AppRoute
        path={`/fragments/:fragmentId/upload/:platform`}
        component={SocialExportUploadPage}
      />
      <AppRoute exact path={`/fragments/s/:slug`} component={FragmentsListStationPage} />
      {/* New routes without station id */}
      <AppRoute path={`/fragments/:fragmentId`} component={FragmentsViewPage} />
      {/* Old routes for backwards compatibility */}
      <AppRoute
        path={`/fragments/s/:slug/fragment/:fragmentId`}
        component={FragmentsViewStationPage}
      />

      {/* catch all: redirect to most recent station or first station */}
      <DefaultStationRedirect to={(s) => `/fragments/s/${s.slug}`} />
    </Switch>
  );
}
